export function Filler(props?: { class?: string }) {
  return <div class={`w-full h-full ${props?.class ?? ""}`} />;
}
